import { FETCH_LOAN_INFO } from '../types'
export default (state = [], action) => {
  switch (action.type) {
    case FETCH_LOAN_INFO:
      return action.payload
    default:
      return state;
  }
}